import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import HospitalRoom from '../Classes/ClvrHospitalRoom'
import { HospitalRoomDto } from '../Types/HospitalRoomDto'

export class HospitalRoomApiAdapter implements ApiDataAdapter<HospitalRoom> {
    public createClass(apiData: HospitalRoomDto): HospitalRoom {
        return new HospitalRoom({
            id: get(apiData, 'id'),
            name: get(apiData, 'nom'),
        })
    }
}
